export default __webpack_public_path__ + "static/Apartamentos-88a0d7cfbe9fe0e6966d76c4073abaa2.svg";